import React from 'react'
import { useTranslation } from 'react-i18next'
import s from './favoriteButton.module.sass'
import { noomean } from '../../../store/commonTypes'
import { useDispatch } from 'react-redux'
import {
    addFavoriteContributionThunk,
    removeFavoriteContributionThunk
} from '../../../store/contributions/contributionsSlice'

interface Props {
    externalState?: noomean
    id: number
    setExternalState?: React.Dispatch<number>
}

const FavoriteButton = ({ externalState = 0, id, setExternalState }: Props) => {
    const [t] = useTranslation()
    const dispatch = useDispatch()
    return (
        <div
            className={s['favorites']}
            onClick={() => {
                if (externalState == 0) {
                    dispatch(addFavoriteContributionThunk({ id: id }))
                    if (setExternalState) setExternalState(1)
                } else {
                    dispatch(removeFavoriteContributionThunk({ id: id }))
                    if (setExternalState) setExternalState(0)
                }
            }}
        >
            {externalState == 1 ? (
                <>
                    <img src={require('../../../assets/ic-star-filled.svg')} alt={'Remove from favorites'}></img>
                    <p>{t('Favorite')}</p>
                </>
            ) : (
                <>
                    <img src={require('../../../assets/ic-star-empty.svg')} alt={'Add to favorites'}></img>
                    <p>{t('Favorite')}</p>
                </>
            )}
        </div>
    )
}

export default FavoriteButton
